"use client";

import { generalAnalitica } from "@/app/(store)/_utils/events";
import { GlobalFeedback } from "@/components/global-feedback";
import { ThemeColors } from "@/components/theme-colors";
import { useEffectOnce } from "@/hooks/use-effect-once";

const NotFoundPage = () => {
  useEffectOnce(() => {
    generalAnalitica.events.view.notFound();
  });

  const theme = global.window?.location.hostname.includes("stone")
    ? "stone-rebrand"
    : "ton";

  return (
    <>
      <ThemeColors theme={theme} />

      <div className={`jade ${theme}`}>
        <GlobalFeedback
          data={{
            icon: "circle-error",
            title: "Não encontramos este catálogo",
            message:
              "O link ou QR Code pode ter mudado. Tente de novo ou peça o novo acesso para a loja.",
          }}
        />
      </div>
    </>
  );
};

export default NotFoundPage;
